import ActNotesForCfe from "./act-notes-for-cfe";
import ActNotesForPdf from "./act-notes-for-pdf";

export default function Remarks() {

    return (
        <div className="flex h-full min-h-0 flex-col overflow-hidden ">
            <div className='flex-1 min-h-0 overflow-y-auto py-2 mb-1'>
                <div className='w-full space-y-3'>
                    <ActNotesForPdf/>
                    <ActNotesForCfe/>
                </div>
            </div>
        </div>
    )
}